import { defaultConfig } from './defaultConfig';

export const config = {
  ...defaultConfig,
  defaultMapZoomLevel: 9,
};
